import { render } from "./Gallery.vue?vue&type=template&id=e56a7780&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=e56a7780&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e56a7780"]])

export default __exports__